var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import SelectField from "../../form/selectfield/SelectField";
import ReadOnly from "../../form/field/ReadOnly";
function ProductSelect(_a) {
    var selectedProduct = _a.selectedProduct, products = _a.products, label = _a.label, onProductChange = _a.onProductChange, productNameTransform = _a.productNameTransform, rest = __rest(_a, ["selectedProduct", "products", "label", "onProductChange", "productNameTransform"]);
    return (React.createElement(React.Fragment, null, products.length > 1 ? (React.createElement(SelectField, __assign({}, rest, { flex: "1", my: 0, label: label, value: selectedProduct.id, onChange: function (e) {
            var pid = parseInt(e.target.value);
            var product = products.find(function (p) { return p.id == pid; });
            if (product) {
                onProductChange(product);
            }
        } }), products.map(function (p) { return (React.createElement("option", { key: p.id, value: p.id },
        productNameTransform ? productNameTransform(p.name, p.id) : p.name,
        !p.in_stock && " (out of stock)")); }))) : (React.createElement(ReadOnly, { label: label, value: selectedProduct.name, my: 0 }))));
}
export default ProductSelect;
//# sourceMappingURL=ProductSelect.js.map